import type { Stripe } from "@stripe/stripe-js";

/**
 * Dev-only injection seam for the Stripe instance the appointment flow hands
 * to `<Elements>`. CI runs without a publishable key, so without a stand-in
 * the card field never mounts there and nothing can check what the booking
 * tree passes to it. Same contract as `setBookingFlowApiOverride`: a hard
 * no-op in production builds, and the only caller is the `/dev/booking-flow`
 * harness (`stripe=fake`), which 404s in production.
 */
let override: Stripe | null = null;

export function setStripeHarnessOverride(next: Stripe | null): void {
  if (process.env.NODE_ENV === "production") return;
  override = next;
}

export function getStripeHarnessOverride(): Stripe | null {
  return override;
}
